/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sport_RideInputs */

const en_ui_sport_ride = /** @type {(inputs: Ui_Sport_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ride`)
};

const de_ui_sport_ride = /** @type {(inputs: Ui_Sport_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrt`)
};

/**
* | output |
* | --- |
* | "Ride" |
*
* @param {Ui_Sport_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sport_ride = /** @type {((inputs?: Ui_Sport_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sport_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sport_ride(inputs)
	return de_ui_sport_ride(inputs)
});